import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DatasharesIntegrationForNro = lazy(() =>
  import("@scenes/DatasharesIntegration/DatasharesIntegrationForNro").then((module) => ({
    default: module.DatasharesIntegrationForNro,
  }))
);

export const datasharesIntegrationNRO: NavigationRoutingObject = {
  Component: DatasharesIntegrationForNro,
  componentFeatureFlippers: ["datashares_integrations", "datashares_integration_nro_component"],
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) => t("datashares-sidebar-pill-menu-option", "Data Sharing"),
  pageNameForTracking: () => "Data Sharing",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "datashares-description-nav",
      "Instantly share new and historical Braze event data to your Snowflake account"
    ),
  icon: "nav-system-data-sharing",
  featureLimitationKeys: ["can_only_view_landing_page_data_sharing"],
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("datashares_integrations");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/datashares_integrations/:appGroupId",
};
